/* istanbul ignore file */
import { FormSection } from 'framework/ui/layout';
import { useShowContext } from 'framework/show';
import { useMessageService, SuccessMessage } from 'framework/ui/Message';
import { ModalForm } from 'framework/form';
import CrmOwnerDropdownInput from 'domain/sales/shared/input/CrmOwnerDropdownInput';
import LeadOwnerNotificationCheckbox from 'domain/sales/lead/shared/input/LeadOwnerNotificationCheckbox';
import useLeadService from 'domain/sales/lead/shared/leadService';

interface AssignLeadOwnerFormProps {
  closeModal: () => void;
  modalOpen: boolean;
  isGranted: boolean;
}

const AssignLeadOwnerForm = ({ closeModal, modalOpen, isGranted }: AssignLeadOwnerFormProps) => {
  const { data: lead, setData: updateLead } = useShowContext();
  const { update } = useLeadService() as any;
  const { addMessage } = useMessageService();
  const leadId = lead.getValueBySource('id');

  return (
    <ModalForm
      closeModal={closeModal}
      modalOpen={modalOpen}
      // @ts-ignore due to unknown issue with ts, code works as expected
      submitFormFunc={data => update(leadId, { ...lead.getData(), ...data })}
      afterSubmit={{
        execute: response => {
          if (updateLead) {
            updateLead(response);
          }
          addMessage(new SuccessMessage('Lead owner has been assigned!'));
        },
      }}
      initialData={{
        status: 'ASSIGNED',
      }}
    >
      <FormSection>
        <CrmOwnerDropdownInput
          source="ownerAlias"
          canUserChange={isGranted}
          dropdownPlaceholder="Choose lead owner"
          label="Lead owner"
        />
        <LeadOwnerNotificationCheckbox source="ownerNotificationEnabled" label="Notify new Owner via Teams" />
      </FormSection>
    </ModalForm>
  );
};

export default AssignLeadOwnerForm;
